/* eslint-disable @nx/enforce-module-boundaries */
import { FormControl,FormErrorMessage, HStack, Input, Link, Spinner, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { JobsListingContext } from '../context';
import { FileInput  } from '@mybridge/ui/file-upload';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Box, Button } from '@chakra-ui/react';
export const JobPreferencesResumeUploader = forwardRef(({isIndividual, ...props }, ref) => {
  const {
    jobPreferences,
    refetchJobPreferences,
    jobPreferencesResume,
    refetchJobPreferencesResume,
    updateJobPreferencesLoading,
    updateJobPreferences,
    removeResume,
    removeJobPreferencesResumeLoading
  } = useContext(JobsListingContext);
  const { loggedIn } = useSelector((state) => state?.user) ?? {};
  const { t } = useTranslator();
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if(loggedIn){
      refetchJobPreferencesResume?.();
    }
  }, [loggedIn]);
  
  const {
    job_availabilty,
    job_alert,
    resume_first,
    resume_first_name,
    resume_second,
    resume_second_name,
  } = jobPreferencesResume ?? {};

  const [uploadingWhich, setUploadingWhich] = useState(null);
  const [removingWhich, setRemovingWhich] = useState(null);

  const uploadResumeFirst = async (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      setUploadingWhich('first');
      try {
        await updateJobPreferences({
          job_availabilty: job_availabilty ?? '0',
          job_alert: job_alert ?? true,
          resume_first: file,
        },'form', true, false, true);
      } finally {
        setUploadingWhich(null);
      }
    }
  };

  const uploadResumeSecond = async (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      setUploadingWhich('second');
      try {
        await updateJobPreferences({
          job_availabilty: job_availabilty ?? '0',
          job_alert: job_alert ?? true,
          resume_second: file,
        },'form', true, false, true);
      } finally {
        setUploadingWhich(null);
      }
    }
  };

  const handleRemoveResume = async (type) => {
    setRemovingWhich(type);
    try {
      await removeResume(type, false, true);
    } finally {
      setRemovingWhich(null);
    }
  };

  return (
    <>
      <FormControl>
        <Stack direction={['column', 'row']} w={['full', 'full', '50%', 'full']} gap={10} mt={2}>
          <Stack>
            {resume_first?.length ? (
              <HStack>
                <Link
                  as={Text}
                  href={resume_first}
                  truncate
                  maxW="150px"
                  target={'_blank'}
                  fontSize={['sm', 'md']}
                  color="brandPrimary.500"
                >
                  {resume_first_name}
                </Link>
                <HStack flex={1} justifyContent="flex-end">
                  <Link color="red" onClick={(e) => handleRemoveResume('first')}>
                    {removeJobPreferencesResumeLoading && removingWhich === 'first' ? <Spinner size={"sm"}/> : (t('profile.remove') || "Remove")}
                  </Link>
                </HStack>
              </HStack>
            ) : (
              <>
                <Text fontSize="sm">
                  {t('profile.acceptedFiles') || "Only pdf, doc, docx and ppt files accepted."}
                </Text>
                <FormControl>
                  <Input
                    id="uploadResumeFirst"
                    isDisabled={updateJobPreferencesLoading}
                    accept=".doc,.docx,.pdf,.ppt"
                    type="file"
                    onChange={uploadResumeFirst}
                    display="none"
                  />
                  <Button
                    bg="transparent"
                    px={2}
                    className="fileInputBlue"
                    fontSize="10px"
                    h="22px"
                    size="xs"
                    variant="outline"
                    colorScheme="blue"
                    isDisabled={updateJobPreferencesLoading}
                    onClick={() => document.getElementById('uploadResumeFirst').click()}
                  >
                    {updateJobPreferencesLoading && uploadingWhich === 'first' ? <Spinner size={'sm'}/> : (t('toast.upload_resume') || "Upload Resume")}
                  </Button>
                </FormControl>
              </>
            )}
          </Stack>

          <Stack>
            {resume_second?.length ? (
              <>
                <HStack>
                  <Link
                    as={Text}
                    href={resume_second}
                    truncate
                    maxW="150px"
                    target={'_blank'}
                    color="brandPrimary.500"
                  >
                    {resume_second_name}
                  </Link>
                  <HStack flex={1} justifyContent="flex-end">
                    <Link color="red" onClick={(e) => handleRemoveResume('second')}>
                      {removeJobPreferencesResumeLoading && removingWhich === 'second' ? <Spinner size={"sm"}/> : (t('profile.remove') || "Remove")}
                    </Link>
                  </HStack>
                </HStack>
              </>
            ) : (
              <>
                <Text fontSize="sm">
                  {t('profile.acceptedFiles') || "Only pdf, doc, docx and ppt files accepted."}
                </Text>
                <FormControl>
                  <Input
                    id="uploadResumeSecond"
                    isDisabled={updateJobPreferencesLoading}
                    accept=".doc,.docx,.pdf,.ppt"
                    type="file"
                    onChange={uploadResumeSecond}
                    display="none"
                  />
                  <Button
                    bg="transparent"
                    px={2}
                    className="fileInputBlue"
                    fontSize="10px"
                    h="22px"
                    size="xs"
                    variant="outline"
                    colorScheme="blue"
                    isDisabled={updateJobPreferencesLoading}
                    onClick={() => document.getElementById('uploadResumeSecond').click()}
                  >
                    {updateJobPreferencesLoading && uploadingWhich === 'second' ? <Spinner size={'sm'}/> : "Upload Secondary Resume"}
                  </Button>
                </FormControl>
              </>
            )}
          </Stack>


        </Stack>
      </FormControl>
    </>
  );
});